import { Box, Panel, Tabs } from '@bigcommerce/big-design';
import OrdersFilters from './components/OrdersFilters';
import OrdersTable from './components/OrdersTable';
import { PRESET, useOrdersList, countQueryResults } from './hooks/useOrderList';
import useSearchFilters, { FILTERS } from './hooks/useSearchFilters';
import { useSelectedItems } from './hooks/useSelectedItems';

export function OrdersListPage() {
	const [filters, setFilter] = useSearchFilters();
	const [
		{ orders, vendors, tags, childTags, countries },
		isLoading,
		fetchOrdersList,
	] = useOrdersList(filters);
	const [{ totalOrderCount }] = countQueryResults(filters);
	const [selectedItems, setSelectedItems] = useSelectedItems(orders);
	return (
		<Panel header="View Orders">
			<Tabs
				activeTab={filters[FILTERS.PRESET]}
				items={PRESET}
				onTabClick={(preset) => setFilter(FILTERS.PRESET, preset)}
			/>
			<Box marginTop="large">
				<OrdersFilters
					preset={filters[FILTERS.PRESET]}
					filters={filters}
					setFilter={setFilter}
					vendors={vendors}
					tags={tags}
					childTags={childTags}
					countries={countries}
					selectedItems={selectedItems}
				/>
				<OrdersTable
					orders={orders}
					setFilter={setFilter}
					totalOrderCount={totalOrderCount}
					isLoading={isLoading}
					selectedItems={selectedItems}
					setSelectedItems={setSelectedItems}
					fetchOrdersList={fetchOrdersList}
					sortField={filters.sortField}
					sortOrder={filters.sortOrder}
					activeTab={filters[FILTERS.PRESET]}
				/>
			</Box>
		</Panel>
	);
}